<template>
  <b-row class="dashboard-indicadores-historico-rentabilidad">
    <b-col cols="12">
      <label class="titulo" v-if="showTitulo">{{ titulo }}</label>
      <b-table hover
          responsive="sm" 
          class="registro"
          :busy="tableBusy"
          :items="indicadoresRentabilidadBruta" 
          :fields="indicadoresRentabilidadBrutaFields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(pjeObjetivo)="data">
          {{ data.item.pjeObjetivo | porcentaje }}
        </template>
        <template v-slot:cell(pjeRentabilidad)="data">
          {{ data.item.pjeRentabilidad | porcentaje }}
        </template>
        <template v-slot:cell(presupuestos)="data">
          {{ data.item.presupuestos }}
        </template>

        <!-- <template v-slot:cell(detailShowing)="row">
          <b-btn class="detailShowing" 
              size="sm" 
              @click.stop="row.toggleDetails">
            {{ ( row.detailsShowing) ? '-' : '+' }}
          </b-btn>            
        </template> -->

        <template v-slot:cell(opciones)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>

            <b-dropdown-item 
                @click.stop="exportarPresupuestos(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Presupuestos</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-col>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </b-row>
</template>

<script>
import Mensaje from  '../../shared/msjModal.vue';
import { msjModal } from '../../../mixins/modalDialogs';

export default {
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    semestral: {
      type: Boolean,
      default: true
    },
    totalNegocio: {
      type: Boolean,
      default: false
    },
    showTitulo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      indicadoresRentabilidadBruta: [],
      indicadoresRentabilidadBrutaFields: [
        { 
          key: 'indicadorPeriodo',
          label: 'Periodo' 
        },
        { 
          key: 'pjeObjetivo',
          class: 'text-right'
        },
        { 
          key: 'pjeRentabilidad',
          label: 'Pje Real',
          class: 'text-right'
        },
        { 
          key: 'presupuestos',
          label: 'Cant. Presupuestos',
          class: 'text-right'
        },
        { 
          key: 'descripcion',
          label: 'Descripción'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],

      tableBusy: false
    }
  },
  computed: {
    titulo() {
      if (this.semestral) {
          return `Rentabilidad Bruta Semestral - ${!this.totalNegocio? 'Sin Reembolsos' : ''}`;
      } else {
        return `Rentabilidad Bruta Anual - ${!this.totalNegocio? 'Sin Reembolsos' : ''}`;
      }
    }
  },
  methods: {
    getIndicadores() {
      let dispatch = '';

      if (this.semestral) {
        if (this.totalNegocio) {
          dispatch = 'resultadosRentabilidadBruta/getIndicadoresRentabilidadSemestralTotalHistorico';
        } else {
          dispatch = 'resultadosRentabilidadBruta/getIndicadoresRentabilidadSemestralHistorico';
        }
      } else {
        if (this.totalNegocio) {
          dispatch = 'resultadosRentabilidadBruta/getIndicadoresRentabilidadAnualTotalHistorico';
        } else {
          dispatch = 'resultadosRentabilidadBruta/getIndicadoresRentabilidadAnualHistorico';
        }
      }

      this.$store.dispatch(dispatch)
        .then(() => {
          this.indicadoresRentabilidadBruta = this.$store.getters['resultadosRentabilidadBruta/indicadoresRentabilidadHistorico'];
        });
    },
    exportarPresupuestos(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
        totalNegocio: this.totalNegocio
      }

      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadBruta/getPresupuestosIndicadorRentabilidadHistorico', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let presupuestos = this.$store.getters['resultadosRentabilidadBruta/resultadosIndicadorRentabilidad'];

          if (presupuestos) {
            if (presupuestos.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Detalle de Presupuestos';
            let fileName = 'rentabilidad-bruta';
            let format = [
              { titulo: 'Nro.Presupuesto', nombre: 'numero', formato: '' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Monto Cotización', nombre: 'importeCotizacion', formato: '' },
              { titulo: 'Monto Financiación', nombre: 'importeFinanciacion', formato: '' },
              { titulo: 'Monto Fee', nombre: 'importeFee', formato: '' },
              { titulo: 'Neto Total', nombre: 'cotizacion', formato: '' },
              { titulo: 'Costo Real', nombre: 'costo', formato: '' },
              { titulo: 'Pje.Rentabilidad', nombre: 'pjeRentabilidad', formato: '' },
            ];

            this.exportXLS(title, fileName, presupuestos, format);

          } else {
            // console.log('No hay datos para exportar.');
            this.showErrorMsj('No hay datos para exportar.')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }
  }
}
</script>

<style>
  .dashboard-indicadores-historico-rentabilidad .registro table td[aria-colindex="1"] {
    width: 25% !important;
  }
  .dashboard-indicadores-historico-rentabilidad .registro table td[aria-colindex="2"],
  .dashboard-indicadores-historico-rentabilidad .registro table td[aria-colindex="3"],
  .dashboard-indicadores-historico-rentabilidad .registro table td[aria-colindex="4"] {
    width: 15% !important;
  }
  .dashboard-indicadores-historico-rentabilidad .registro table td[aria-colindex="5"] {
    width: calc(30% - 60px) !important;
  }
  .dashboard-indicadores-historico-rentabilidad .registro table td[aria-colindex="6"] {
    width: 60px !important;
  }
</style>